<div class="shop-description-wrapper" [class.clickable]="showButton" (click)="toggle()">
  <p #text class="shop-description-text ods-typography-body-s-regular" [class.collapsed]="collapsed">
    {{ description }}
  </p>
  <button class="shop-description-button" *ngIf="showButton" mat-icon-button>
    <mat-icon>{{ buttonIcon }}</mat-icon>
  </button>
</div>
